(function () {
  'use strict';

  function initFooter(footer) {
    if (!footer || footer.dataset.wantedFooterReady === 'true') return;
    footer.dataset.wantedFooterReady = 'true';

    var accordions = footer.querySelectorAll('[data-wanted-footer-accordion]');
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function isMobile() {
      return mobileQuery.matches;
    }

    function closePanel(item) {
      var toggle = item.querySelector('[data-wanted-footer-toggle]');
      var panel = item.querySelector('[data-wanted-footer-panel]');
      if (!toggle || !panel) return;

      toggle.setAttribute('aria-expanded', 'false');
      panel.classList.remove('is-open');
      panel.style.maxHeight = '0px';
    }

    function openPanel(item) {
      var toggle = item.querySelector('[data-wanted-footer-toggle]');
      var panel = item.querySelector('[data-wanted-footer-panel]');
      if (!toggle || !panel) return;

      toggle.setAttribute('aria-expanded', 'true');
      panel.classList.add('is-open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }

    function closeOtherPanels(currentItem) {
      accordions.forEach(function (item) {
        if (item !== currentItem) closePanel(item);
      });
    }

    accordions.forEach(function (item) {
      var toggle = item.querySelector('[data-wanted-footer-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        if (!isMobile()) return;

        var expanded = toggle.getAttribute('aria-expanded') === 'true';

        if (expanded) {
          closePanel(item);
        } else {
          closeOtherPanels(item);
          openPanel(item);
        }
      });
    });

    function syncLayout() {
      accordions.forEach(function (item) {
        var panel = item.querySelector('[data-wanted-footer-panel]');
        var toggle = item.querySelector('[data-wanted-footer-toggle]');
        if (!panel || !toggle) return;

        if (isMobile()) {
          if (toggle.getAttribute('aria-expanded') === 'true') {
            panel.classList.add('is-open');
            panel.style.maxHeight = panel.scrollHeight + 'px';
          } else {
            panel.classList.remove('is-open');
            panel.style.maxHeight = '0px';
          }
        } else {
          panel.classList.remove('is-open');
          panel.style.maxHeight = '';
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(syncLayout, 80);
    }, { passive: true });

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', syncLayout);
    }

    syncLayout();
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-wanted-footer]').forEach(initFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
